export const renderInfinityChannels = ({ value }) =>
  value === -1 ? Infinity.toLocaleString() : value;
